<template>
  <div class="overlay">
    <v-row justify="space-around">
      <v-sheet :light="true">
        <v-toolbar-title class="toolbar-title"
          >Add a New Course</v-toolbar-title
        >
        <div>
          <v-overlay :value="showAssignBadge" class="d-flex">
            <div class="d-flex justify-end">
              <v-btn icon @click="showAssignBadge = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>
            <badge-select v-on:badge:select="selectBadge" />
          </v-overlay>

          <base-badge
            badgeIcon="mdi-pencil"
            badgeColor="green"
            class="center-align"
            :imageUrl="imageUrl"
            style="padding-top: 10px;"
            v-on:badge:click="showAssignBadge = true"
          ></base-badge>
          <div>
            <v-text-field
              id="js-course-name-input"
              label="Name"
              v-model="name"
              :rules="textFieldRules"
            ></v-text-field>
            <v-text-field
              id="js-course-description-input"
              label="Description"
              v-model="description"
              :rules="textFieldRules"
            ></v-text-field>
          </div>
        </div>
        <v-btn id="js-course-add" color="primary" @click="addCourse">Add</v-btn>
      </v-sheet>
    </v-row>
  </div>
</template>

<script>
import eventMixin from "@/mixins/eventMixin"
import validationMixin from "@/mixins/validationMixin"
import EventBus from "@/lib/eventBus"
import BaseBadge from "@/components/BaseBadge"
import BadgeSelect from "@/containers/badges/BadgeSelect"

export default {
  components: {
    BaseBadge,
    BadgeSelect
  },
  mixins: [validationMixin],
  data: function() {
    return {
      badgeId: "",
      imageUrl: "",
      name: "",
      description: "",
      showAssignBadge: false
    }
  },
  methods: {
    selectBadge(e) {
      this.imageUrl = e.url
      this.badgeId = e.id
      this.showAssignBadge = false
    },
    addCourse() {
      this.$store
        .dispatch("courses/addCourse", {
          badgeId: this.badgeId,
          name: this.name,
          description: this.description,
          template: true
        })
        .then(() => {
          this.$emit("close:overlay")
        })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../scss/variables";
div.overlay {
  min-width: 330px;
}
div.v-sheet {
  padding: 15px;
  width: 150%;
}
.center-align {
  display: flex;
  justify-content: center;
}
.toolbar-title {
  font-weight: 700;
  color: $orange;
  text-align: center;
}
</style>
